import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import PaceProgressActions from '../../actions/PaceProgressActions';

const PaceProgress = ({ 
    active: propActive, 
    total: propTotal, 
    uploaded: propUploaded,
    onEndLoading: propOnEndLoading
}) => {
    const [active, setActive] = useState(propActive);
    const [total, setTotal] = useState(propTotal);
    const [uploaded, setUploaded] = useState(propUploaded);
    const [width, setWidth] = useState(0);

    const getWidth = useCallback((total, uploaded) => {
        if (!total || total === 0) return 0;
        return Math.round((uploaded / total) * 100);
    }, []);

    const onEndLoading = useCallback(() => {
        if (propOnEndLoading) {
            propOnEndLoading();
        }
    }, [propOnEndLoading]);

    // Initial setup
    useEffect(() => {
        setWidth(getWidth(propTotal, propUploaded));
        PaceProgressActions.startUpdatePage();
    }, [propTotal, propUploaded, getWidth]);

    // Sync with props changes
    useEffect(() => {
        const isEndLoading = !propActive && !propTotal && !propUploaded;
        setActive(propActive);
        setTotal(propTotal);
        setUploaded(propUploaded);
        
        if (isEndLoading) {
            onEndLoading();
        } else {
            setWidth(getWidth(propTotal, propUploaded));
        }
    }, [propActive, propTotal, propUploaded, getWidth, onEndLoading]);

    const getClassProgress = useCallback(() => {
        return classNames({
            'pace-progress': true,
            'active': active
        });
    }, [active]);

    if (!active || total === 0) {
        return null;
    }

    return (
        <div className={getClassProgress()}>
            <div className="pace-progress__bar">
                <div 
                    className="pace-progress__bar__fill"
                    style={{ width: `${width}%` }}
                />
            </div>
        </div>
    );
};

PaceProgress.propTypes = {
    active: PropTypes.bool,
    total: PropTypes.number,
    uploaded: PropTypes.number,
    onEndLoading: PropTypes.func
};

PaceProgress.defaultProps = {
    active: false,
    total: 0,
    uploaded: 0
};

export default PaceProgress;